import { forwardRef, memo } from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { HintProps } from './hint.types';
import { ScrollArea, TooltipContent } from './hint.styled';
import { Text } from '../text';

export const Hint = memo(
  forwardRef<HTMLDivElement, HintProps>(
    (
      {
        content,
        html = false,
        children,
        delayDuration = 300,
        enabled = true,
        portalContainer,
        ...restProps
      },
      forwardedRef
    ) => {
      if (!enabled) {
        return <>{children}</>;
      }

      const hintInner = (
        <TooltipContent
          ref={forwardedRef}
          sideOffset={8}
          collisionPadding={8}
          arrowPadding={24}
          {...restProps}
        >
          <ScrollArea>
            {html ? (
              <Text
                align="center"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            ) : (
              <Text align="center" style={{ whiteSpace: 'pre-wrap' }}>
                {content}
              </Text>
            )}
          </ScrollArea>

          <RadixTooltip.Arrow asChild>
            <svg
              width="17"
              height="8"
              viewBox="0 0 17 8"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              className="tooltip-arrow"
            >
              <path d="M17 -0.00868225L9.93175 7.06521C9.15102 7.84657 7.88469 7.84707 7.10333 7.06633L0.029439 -0.00191164L8.51133 -8.49058L17 -0.00868225Z" />
            </svg>
          </RadixTooltip.Arrow>
        </TooltipContent>
      );

      return (
        <RadixTooltip.Provider>
          <RadixTooltip.Root delayDuration={delayDuration}>
            <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>

            {portalContainer ? (
              <RadixTooltip.Portal container={portalContainer}>
                {hintInner}
              </RadixTooltip.Portal>
            ) : (
              hintInner
            )}
          </RadixTooltip.Root>
        </RadixTooltip.Provider>
      );
    }
  )
);

Hint.displayName = 'Hint';
